import { render, staticRenderFns } from "./button-renderer.vue?vue&type=template&id=72868a2c&scoped=true"
import script from "./button-renderer.vue?vue&type=script&lang=js"
export * from "./button-renderer.vue?vue&type=script&lang=js"
import style0 from "./button-renderer.vue?vue&type=style&index=0&id=72868a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72868a2c",
  null
  
)

export default component.exports